<template>
  <div>
    <div class="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between my-8">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Files & Links
      </h3>
      <div class="mt-3 sm:mt-0 sm:ml-4">
        <button @click="newFileClicked" type="button" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400">
          Add File
        </button>
        <button @click="newLinkClicked" type="button" class="ml-2 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400">
          Add Link
        </button>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200 z-20">
              <thead class="bg-gray-100">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                    Label
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                    Type
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                    Required Agreement
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                    Show on Sponsor Form
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                    Preview
                  </th>
                  <th scope="col" class="relative px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(f, i) in event.files" :key="i" :class="i % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{f.label}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{f.type}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{ f.required_agreement }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{f.show_on_sponsor_form}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    <template v-if="f.type === 'file'">
                      <button class="link hidden md:block" @click="previewFileClicked(f)">Preview File</button>
                      <a class="link md:hidden" :href="f.url" target="_blank">View File</a>
                    </template>
                    <template v-else>
                      <a class="link" :href="f.url" target="_blank">Go to Link</a>
                    </template>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-right text-sm  space-x-3">
                    <button class="text-blue-500 hover:text-blue-700" @click="editFileClicked(f)">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button class="text-red-500 hover:text-red-700" @click="removeFileClicked(f, i)">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <b-modal static ref="fileModal" title="Manage File">
      <div class="flex justify-start px-2 py-4 items-center">
        <form @submit.prevent class="text-sm md:text-base">
          <div class="flex flex-col justify-start md:justify-start space-y-4">
            <div class="w-full">
              <label class="form-label">Label</label>
              <input class="new-form-input mt-1 w-full" v-model="file.label" placeholder="Label">
              <p class="mt-1 text-sm text-gray-600" id="label-description">This is a short form label for the file that exhibtiors will see. (i.e. Show Schedule, Show Rules, Health Waiver, etc.)</p>
            </div>
            <fieldset class="flex flex-col space-y-3 mt-4">
              <legend class="sr-only">Settings</legend>
              <div class="relative flex items-center">
                <div class="flex items-center h-5">
                  <input v-model="file.required_agreement" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                </div>
                <div class="ml-3 text-sm">
                  <label for="comments" class="font-medium text-gray-700">Require Agreement</label>
                  <p id="comments-description" class="text-gray-600">Require the exhitors to acknowledge agreement to the contents of this file before starting the entries for the show.</p>
                </div>
              </div>
            </fieldset>
            <fieldset class="flex flex-col space-y-3 mt-4">
              <legend class="sr-only">Settings</legend>
              <div class="relative flex items-center">
                <div class="flex items-center h-5">
                  <input v-model="file.show_on_sponsor_form" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                </div>
                <div class="ml-3 text-sm">
                  <label for="comments" class="font-medium text-gray-700">List on Sponsor Form</label>
                  <p id="comments-description" class="text-gray-600">If you want this file listed on the online sponsor form.</p>
                </div>
              </div>
            </fieldset>
            <div class="w-full">
              <template v-if="file.type === 'file'">
                <template v-if="!file.url">
                  <label class="form-label"></label>
                  <FilePondUploadWidget ref="uploadWidget" @fileUpdated="fileUpdated"/>
                  <p class="mt-1 text-sm text-gray-600" id="label-description">No file currently addded either click or drag & drop to upload a file.</p>
                </template>
                <template v-else>
                  <div class="text-center">
                    <button class="btn btn-red-outline my-2" @click="replaceFileClicked()">Replace File</button>
                  </div>
                  <iframe class="w-full h-96" style="height: 30rem;" :src="file.url"></iframe>
                </template>
              </template>
              <template v-else-if="file.type === 'link'">
                <label class="form-label">Link Url</label>
                <input class="new-form-input mt-1 w-full" v-model="file.url" placeholder="https://file.com/123">
                <p class="mt-1 text-sm text-gray-600" id="label-description">Paste the full url to the file/webpage here. Inlcuding the "https://"" at the begining</p>
              </template>
            </div>
          </div>
        </form>
      </div>
      <button class="btn btn-blue" @click="updateAddFile">Save File</button>

      <div slot="modal-footer" class="w-100">
        <div class="flex justify-end">
          <button class="btn-red-outline btn" variant="primary" @click="cancelFileUpload">
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="filePreview" title="File Preview">
      <iframe class="w-full h-screen" :src="previewFile.url"></iframe>
    </b-modal>
  </div>
</template>

<script>
import FilePondUploadWidget from '@/components/FilePondUploadWidget.vue'
import notie from 'notie'

export default {
  components: {
    FilePondUploadWidget
  },
  props: {
    event: Object
  },
  data () {
    return {
      file: {},
      editFileIndex: null,
      previewFile: {}
    }
  },
  methods: {
    removeFileClicked (file, index) {
      notie.confirm({
        text: `Are you sure you want to delete the ${file.label} file? All data associated with this question will be removed from your show.`,
        submitCallback: () => {
          this.event.files.splice(index, 1)
          this.saveEventFiles()
        }
      })
    },
    editFileClicked (file) {
      this.file = file
      this.$refs.fileModal.show()
    },
    newFileClicked () {
      this.file = {
        isNew: true,
        notSaved: true,
        type: 'file'
      }
      this.$refs.fileModal.show()
    },
    newLinkClicked () {
      this.file = {
        isNew: true,
        notSaved: true,
        type: 'link'
      }
      this.$refs.fileModal.show()
    },
    updateAddFile () {
      if (this.file.isNew) {
        this.event.files.push({
          label: this.file.label,
          url: this.file.url,
          required_agreement: this.file.required_agreement,
          type: this.file.type
        })
      }
      this.saveEventFiles()
    },
    fileUpdated (url) {
      this.$set(this.file, 'url', url)
    },
    replaceFileClicked () {
      // If there is already an old_url delete it
      if (this.file.old_url) {
        this.deleteFile(this.file.old_url, this.file.type)
      }
      this.file.old_url = this.file.url
      this.file.url = null
      this.file.notSaved = true
    },
    cancelFileUpload () {
      // console.log('cancel')
      if ((this.file.url === null && this.file.old_url) || this.file.notSaved) {
        if (this.file.url) {
          this.deleteFile(this.file.url, this.file.type)
          this.file.url = this.file.old_url
        } else if (this.file.isNew && this.file.old_url) {
          this.deleteFile(this.file.old_url, this.file.type)
        }
      }

      this.$refs.fileModal.hide()
    },
    saveEventFiles () {
      this.file.notSaved = false
      if (this.file.old_url) {
        // Delete the old file
        this.deleteFile(this.file.old_url, this.file.type)
        this.file.old_url = null
      }
      // Save the new file_json
      this.$store.dispatch('updateFiles', {
        event_id: this.event.event_id,
        files: this.event.files
      }).then(response => {
        this.notie.alert({
          type: 1,
          text: 'File Updated'
        })
        // // console.log(response)
      }).catch(() => {
        // console.log(error)
        this.notie.alert({
          type: 2,
          text: 'Error saving File'
        })
      })
      this.$refs.fileModal.hide()
    },
    previewFileClicked (file) {
      this.previewFile = file
      this.$refs.filePreview.show()
    },
    deleteFile (url, type) {
      if (type === 'file') {
        return this.$store.state.apiInstance.delete(`/upload/delete/${url.split('com/')[1]}`)
          .then(response => {
            // console.log(response)
          })
      }
    }
  }
}
</script>

<style>

</style>
